/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Bulk_Count_ReadsInputs */



/**
* | output |
* | --- |
* | "{count} reads" |
*
* @param {Chat_Tool_Bulk_Count_ReadsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_count_reads = /** @type {((inputs: Chat_Tool_Bulk_Count_ReadsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Count_ReadsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Lesevorgänge`)
	return /** @type {LocalizedString} */ (`${i?.count} reads`)
});